<template>
  <tr>
    <td>{{ channel.order }}</td>
    <td>{{ channel.name }}</td>
    <td>{{ channel.moderators.join(', ') }}</td>
    <td class="text-center">{{ channel.locked ? 'Yes' : 'No' }}</td>
    <td class="text-lg flex justify-center">
      <a class="text-blue-7 hover:text-blue-5 mx-1 cursor-pointer" @click="show.image = true">
        <image-icon></image-icon>
      </a>
      <a class="text-green-7 hover:text-green-5 mx-1 cursor-pointer" @click="show.edit = true">
        <edit-icon></edit-icon>
      </a>
      <a class="text-red-7 hover:text-red-5 mx-1 cursor-pointer" @click="show.delete = true">
        <trash2-icon></trash2-icon>
      </a>
    </td>

    <portal to="modal-portal">
      <channel-update-form
        v-if="show.edit"
        :category="category"
        :existing="channel"
        @close="show.edit = false"
        @success="success('edit')"
      />
    </portal>

    <portal to="modal-portal">
      <channel-image-form
        v-if="show.image"
        :category="category"
        :existing="channel"
        @close="show.image = false"
        @success="success('image')"
      />
    </portal>

    <portal to="modal-portal">
      <prompt v-if="show.delete" @close="show.delete = false" @confirm="deleteChannel">
        This will delete {{ channel.name }} along with all associated Threads & Replies. This cannot be undone.
        <br />Are you sure?
      </prompt>
    </portal>
  </tr>
</template>

<script>
import { mapActions } from "vuex"
import ChannelUpdateForm from "@/components/Forms/ChannelUpdateForm"
import ChannelImageForm from "@/components/Forms/ChannelImageForm"
import { EditIcon, Trash2Icon, ImageIcon } from "vue-feather-icons"

export default {
  name: "ChannelRow",
  components: {
    ChannelUpdateForm,
    ChannelImageForm,
    EditIcon,
    Trash2Icon,
    ImageIcon
  },
  props: {
    channel: {
      required: true
    },
    category: {
      required: true
    }
  },
  data() {
    return {
      show: {
        edit: false,
        delete: false,
        image: false
      }
    }
  },
  methods: {
    ...mapActions({
      fetch: "categories/fetch"
    }),
    success(form) {
      this.show[form] = false
      this.fetch()
    },
    deleteChannel() {
      this.show.delete = false
      this.$api.channels
        .destroy(this.category.slug, this.channel.slug)
        .then(() => {
          this.$toasted.success("Channel deleted.")
          this.fetch()
        })
        .catch(() => {
          this.$error.generic()
        })
    }
  }
}
</script>
